function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "resiliency_svg__d",
  width: "154.8%",
  height: "164.1%",
  x: "-27.8%",
  y: "-31.2%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 9.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0.533333333 0 0 0 0 0.6 0 0 0 0 0.682352941 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("filter", {
  id: "resiliency_svg__g",
  width: "154.8%",
  height: "164.1%",
  x: "-27.8%",
  y: "-31.2%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 9.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0.533333333 0 0 0 0 0.6 0 0 0 0 0.682352941 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("filter", {
  id: "resiliency_svg__j",
  width: "154.8%",
  height: "164.1%",
  x: "-27.8%",
  y: "-31.2%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 9.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0.533333333 0 0 0 0 0.6 0 0 0 0 0.682352941 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("filter", {
  id: "resiliency_svg__m",
  width: "154.8%",
  height: "164.1%",
  x: "-27.8%",
  y: "-31.2%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 9.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0.533333333 0 0 0 0 0.6 0 0 0 0 0.682352941 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("filter", {
  id: "resiliency_svg__n",
  width: "154.8%",
  height: "164.1%",
  x: "-27.8%",
  y: "-31.2%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 9.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0.533333333 0 0 0 0 0.6 0 0 0 0 0.682352941 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("filter", {
  id: "resiliency_svg__p",
  width: "154.8%",
  height: "164.1%",
  x: "-27.8%",
  y: "-31.2%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 9.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0.533333333 0 0 0 0 0.6 0 0 0 0 0.682352941 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("filter", {
  id: "resiliency_svg__q",
  width: "154.8%",
  height: "164.1%",
  x: "-27.8%",
  y: "-31.2%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 9.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0.533333333 0 0 0 0 0.6 0 0 0 0 0.682352941 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("filter", {
  id: "resiliency_svg__r",
  width: "154.8%",
  height: "164.1%",
  x: "-27.8%",
  y: "-32.1%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 9.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0.533333333 0 0 0 0 0.6 0 0 0 0 0.682352941 0 0 0 0.496831294 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("filter", {
  id: "resiliency_svg__s",
  width: "154.8%",
  height: "164.1%",
  x: "-27.8%",
  y: "-32.1%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 9.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0.533333333 0 0 0 0 0.6 0 0 0 0 0.682352941 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("filter", {
  id: "resiliency_svg__u",
  width: "154.8%",
  height: "164.1%",
  x: "-27.8%",
  y: "-31.2%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 9.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0.533333333 0 0 0 0 0.6 0 0 0 0 0.682352941 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("filter", {
  id: "resiliency_svg__v",
  width: "154.8%",
  height: "164.1%",
  x: "-27.8%",
  y: "-31.2%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 9.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0.533333333 0 0 0 0 0.6 0 0 0 0 0.682352941 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "resiliency_svg__a",
  x1: "-30.039%",
  x2: "173.382%",
  y1: "89.778%",
  y2: "-69.513%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#E4E8F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "resiliency_svg__e",
  x1: "50%",
  x2: "50%",
  y1: "93.016%",
  y2: "-6.984%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopOpacity: 0.935
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#303234"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "resiliency_svg__f",
  x1: "100%",
  x2: "0%",
  y1: "43.016%",
  y2: "43.016%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopOpacity: 0.935
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#303234"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "resiliency_svg__h",
  x1: "29.95%",
  x2: "29.95%",
  y1: "-10.057%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#E4E8F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "resiliency_svg__i",
  x1: "74.962%",
  x2: "26.276%",
  y1: "3.622%",
  y2: "94.701%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E4E8F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#C9CDD9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "resiliency_svg__k",
  x1: "50%",
  x2: "50%",
  y1: "105.339%",
  y2: "5.339%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00907F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#48D59F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "resiliency_svg__l",
  x1: "0%",
  y1: "55.339%",
  y2: "55.339%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00907F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#48D59F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "resiliency_svg__t",
  x1: "29.95%",
  x2: "29.95%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#E4E8F2"
})), /*#__PURE__*/React.createElement("path", {
  id: "resiliency_svg__b",
  d: "M0 0h485v454H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "resiliency_svg__o",
  d: "M92.207 58.02c.219.215.346.484.365.787 0 .286-.128.572-.347.77L71.413 79.06c-.2.197-.474.304-.747.304-.274 0-.529-.107-.747-.304l-2.515-2.36a1.048 1.048 0 01-.347-.768c0-.286.128-.572.347-.769l17.459-16.357-17.46-16.356a1.048 1.048 0 01-.346-.77c0-.285.128-.571.347-.768l2.515-2.36c.2-.196.492-.303.747-.303s.528.107.747.304L92.207 58.02zm-61.926.787L47.74 75.164c.218.197.346.483.346.769 0 .286-.128.572-.346.769l-2.515 2.36c-.2.196-.474.303-.748.303-.255 0-.528-.107-.747-.304L22.918 59.576a1.048 1.048 0 01-.346-.769c0-.286.127-.572.346-.768L43.73 38.554c.2-.197.492-.304.747-.304s.529.107.748.304l2.515 2.36c.218.196.346.482.346.768 0 .286-.128.572-.346.769L30.28 58.807zm16.033-4.628l4.256 4.276a.5.5 0 010 .705l-4.256 4.275a.5.5 0 01-.709 0L41.35 59.16a.5.5 0 010-.705l4.256-4.276a.5.5 0 01.709 0zm23.388 0l4.256 4.276a.5.5 0 010 .705l-4.256 4.275a.5.5 0 01-.709 0l-4.256-4.275a.5.5 0 010-.705l4.256-4.276a.5.5 0 01.709 0zm-11.694 0l4.256 4.276a.5.5 0 010 .705l-4.256 4.275a.5.5 0 01-.709 0l-4.256-4.275a.5.5 0 010-.705l4.256-4.276a.5.5 0 01.709 0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#resiliency_svg__a)",
  d: "M21.831 315.96c-24.535-29.252-29.537-79.413-9.124-127.965C36.652 131.041 99.99 74.022 157.56 44.637 377.288-67.51 570.256 130.96 476.899 312.581c-37.072 72.042-74.735 120.637-109.204 149.938l-2.397 2.01c-78.978 65.365-140.6 29.11-138.805-57.902 1.642-80.887-19.166-123.932-78.381-88.05-57.705 34.966-101.74 26.622-126.267-2.6l-.014-.016z",
  transform: "translate(0 19)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(59 28)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "resiliency_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#resiliency_svg__b"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#111",
  strokeLinecap: "square",
  strokeOpacity: 0.05,
  mask: "url(#resiliency_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M578 352.5H-24m602 41H-24m602 40H-24m602 40H-24m602-282H-24m602 40H-24m602 41H-24m602 40H-24m602-282H-24m602 40H-24m602 41H-24m602 40H-24m602-161H-24m120 482v-602m-41 602v-602m-40 602v-602m-40 602v-602m282 602v-602m-40 602v-602m-41 602v-602m-40 602v-602m282 602v-602m-40 602v-602m-41 602v-602m-40 602v-602m202 602v-602m-41 602v-602"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#resiliency_svg__d)",
  transform: "translate(189 238)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#resiliency_svg__e)",
  d: "M58.096.124v117.063h17.891c32.334 0 58.5-26.185 58.5-58.531 0-15.403-6.158-30.293-16.934-41.588C106.263 6.286 91.382.124 75.987.124H58.096z",
  transform: "translate(-.428 .326)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M57.7.451c32.104 0 58.129 26.206 58.129 58.532 0 32.326-26.025 58.531-58.128 58.531S-.427 91.31-.427 58.983 25.598.45 57.701.45"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#resiliency_svg__f)",
  d: "M58.129.125c32.103 0 58.128 26.206 58.128 58.532 0 32.326-26.025 58.531-58.128 58.531S0 90.983 0 58.657 26.026.125 58.129.125",
  opacity: 0.749,
  transform: "translate(-.428 .326)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M77.46 76.428H39.683V38.544H77.46v37.884zm15.112-22.73V46.12h-7.556v-7.577c0-4.205-3.4-7.577-7.556-7.577h-7.555V23.39h-7.556v7.577h-7.555V23.39h-7.556v7.577h-7.555a7.54 7.54 0 00-7.556 7.577v7.577h-7.555v7.577h7.555v7.577h-7.555v7.576h7.555v7.577c0 4.185 3.383 7.577 7.556 7.577h7.555v7.577h7.556v-7.577h7.555v7.577h7.556v-7.577h7.555c4.173 0 7.556-3.392 7.556-7.577v-7.577h7.556v-7.576h-7.556v-7.577h7.556zm-30.223 7.577h-7.555v-7.577h7.555v7.577zm7.556-15.154H47.238v22.73h22.667v-22.73z"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#resiliency_svg__g)",
  transform: "translate(104 167)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#resiliency_svg__h)",
  d: "M58.096.124v117.063h17.891c32.334 0 58.5-26.185 58.5-58.531 0-15.403-6.158-30.293-16.934-41.588C106.263 6.286 91.382.124 75.987.124H58.096z",
  transform: "translate(-.428 .225)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M57.7.35c32.104 0 58.129 26.206 58.129 58.532 0 32.326-26.025 58.531-58.128 58.531S-.427 91.208-.427 58.882 25.598.35 57.701.35"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#resiliency_svg__i)",
  d: "M58.129.125c32.103 0 58.128 26.206 58.128 58.532 0 32.326-26.025 58.531-58.128 58.531S0 90.983 0 58.657 26.026.125 58.129.125",
  opacity: 0.749,
  transform: "translate(-.428 .225)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M57.563 24.293h-.114c-9.054.033-17.552 3.59-23.958 10.016-6.39 6.442-9.92 14.982-9.92 24.08 0 9.098 3.53 17.638 9.937 24.08 6.39 6.426 14.904 9.983 23.957 10.016h.115c18.744 0 33.992-15.294 33.992-34.096 0-18.802-15.264-34.096-34.009-34.096zm29.45 31.801H74.33c-.148-4.377-.687-8.557-1.602-12.49a49.702 49.702 0 008.122-3.443c3.595 4.622 5.72 10.097 6.161 15.933zm-31.738 0H45.176c.13-4.016.621-7.82 1.438-11.327a49.576 49.576 0 008.661 1.164v10.163zm0 4.59V70.83a49.786 49.786 0 00-8.66 1.163c-.818-3.507-1.308-7.31-1.439-11.31h10.1zm4.576 0H69.87c-.13 4-.62 7.803-1.438 11.294a48.64 48.64 0 00-8.58-1.147V60.684zm0-4.59V45.931a49.787 49.787 0 008.58-1.148c.817 3.508 1.307 7.295 1.438 11.311H59.851zM77.73 36.768a45.32 45.32 0 01-6.21 2.54c-1.16-3.508-2.631-6.54-4.331-8.933a29.556 29.556 0 0110.54 6.393zm-10.525 3.72a45.86 45.86 0 01-7.354.984V29.44c2.778 1.508 5.491 5.557 7.354 11.049zm-11.93-11.113v12.08a45.07 45.07 0 01-7.435-1c1.895-5.54 4.641-9.589 7.435-11.08zm-7.452 1.049c-1.683 2.377-3.137 5.393-4.298 8.868a46.34 46.34 0 01-6.128-2.524 29.11 29.11 0 0110.426-6.344zm-13.547 9.753a48.717 48.717 0 008.04 3.41c-.931 3.917-1.47 8.114-1.601 12.49H28.13c.425-5.802 2.55-11.277 6.145-15.9zm-6.161 20.507h12.583c.147 4.377.687 8.573 1.602 12.49a51.69 51.69 0 00-8.04 3.41 29.424 29.424 0 01-6.145-15.9zM37.38 80.01a45.657 45.657 0 016.144-2.524c1.16 3.491 2.615 6.491 4.298 8.884a29.838 29.838 0 01-10.442-6.36zm10.459-3.704a45.305 45.305 0 017.435-1v12.097c-2.81-1.492-5.54-5.557-7.435-11.097zM59.85 87.338V75.289a45.86 45.86 0 017.354.984c-1.863 5.508-4.576 9.556-7.354 11.065zm7.354-.935c1.7-2.393 3.17-5.426 4.331-8.934a44.575 44.575 0 016.21 2.558 29.894 29.894 0 01-10.54 6.376zm13.646-9.802a49.702 49.702 0 00-8.122-3.443c.915-3.917 1.454-8.097 1.602-12.474h12.681a29.29 29.29 0 01-6.16 15.917z"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#resiliency_svg__j)",
  transform: "translate(22 95)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#resiliency_svg__k)",
  d: "M58.096.124v117.063h17.891c32.334 0 58.5-26.185 58.5-58.531 0-15.403-6.158-30.293-16.934-41.588C106.263 6.286 91.382.124 75.987.124H58.096z",
  transform: "translate(-.428 .135)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M57.7.26c32.104 0 58.129 26.206 58.129 58.532 0 32.326-26.025 58.531-58.128 58.531S-.427 91.118-.427 58.792 25.598.26 57.701.26"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#resiliency_svg__l)",
  d: "M58.129.125c32.103 0 58.128 26.206 58.128 58.532 0 32.326-26.025 58.531-58.128 58.531S0 90.983 0 58.657 26.026.125 58.129.125",
  transform: "translate(-.428 .135)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M74.64 81.526h-6.726v-8.765a2.018 2.018 0 10-4.037 0v8.765H49.092v-8.765a2.018 2.018 0 10-4.037 0v8.765h-6.727v-8.765a2.018 2.018 0 10-4.036 0v8.765h-10.42a.3.3 0 01-.3-.3v-44.69a.3.3 0 01.3-.3h66.3a.3.3 0 01.3.3v44.69a.3.3 0 01-.3.3H78.678v-8.765a2.018 2.018 0 10-4.036 0v8.765zM31.477 41.628a.4.4 0 00-.4.4v20.766c0 .221.18.4.4.4H43.54a.4.4 0 00.4-.4V42.028a.4.4 0 00-.4-.4H31.476zm19.296 0a.4.4 0 00-.4.4v20.766c0 .221.18.4.4.4h12.064a.4.4 0 00.4-.4V42.028a.4.4 0 00-.4-.4H50.772zm19.296 0a.4.4 0 00-.4.4v20.766c0 .221.18.4.4.4h12.064a.4.4 0 00.4-.4V42.028a.4.4 0 00-.4-.4H70.068z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M33.918 44.572H41.3a.4.4 0 01.4.4V59.85a.4.4 0 01-.4.4h-7.382a.4.4 0 01-.4-.4V44.972a.4.4 0 01.4-.4zm19.236 0h7.383c.22 0 .4.18.4.4V59.85a.4.4 0 01-.4.4h-7.383a.4.4 0 01-.4-.4V44.972c0-.22.18-.4.4-.4zm19.237 0h7.382a.4.4 0 01.4.4V59.85a.4.4 0 01-.4.4h-7.382a.4.4 0 01-.4-.4V44.972a.4.4 0 01.4-.4z"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#resiliency_svg__m)",
  transform: "translate(271 315)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#resiliency_svg__h)",
  d: "M58.096.124v117.063h17.891c32.334 0 58.5-26.185 58.5-58.531 0-15.403-6.158-30.293-16.934-41.588C106.263 6.286 91.382.124 75.987.124H58.096z",
  transform: "translate(-.428 .255)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M57.7.38c32.104 0 58.129 26.206 58.129 58.532 0 32.326-26.025 58.531-58.128 58.531S-.427 91.238-.427 58.912 25.598.38 57.701.38"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#resiliency_svg__i)",
  d: "M58.129.125c32.103 0 58.128 26.206 58.128 58.532 0 32.326-26.025 58.531-58.128 58.531S0 90.983 0 58.657 26.026.125 58.129.125",
  opacity: 0.749,
  transform: "translate(-.428 .255)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M70.69 73.114l3.085-7.671 7.635 3.1-3.085 7.67-7.635-3.1zm7.973-16.999l7.712-19.177 7.636 3.1-7.713 19.177-7.635-3.1zm-21.15 10.576c-4.57 0-8.235-3.723-8.235-8.273 0-4.592 3.665-8.273 8.235-8.273 4.548 0 8.235 3.704 8.235 8.273 0 4.57-3.687 8.273-8.235 8.273zm0-41.366c-18.193 0-32.941 14.816-32.941 33.093S39.32 91.511 57.513 91.511a32.865 32.865 0 0023.293-9.693 33.17 33.17 0 009.648-23.4c0-18.277-14.748-33.093-32.94-33.093z"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#resiliency_svg__n)",
  transform: "translate(104 315)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#resiliency_svg__h)",
  d: "M58.096.124v117.063h17.891c32.334 0 58.5-26.185 58.5-58.531 0-15.403-6.158-30.293-16.934-41.588C106.263 6.286 91.382.124 75.987.124H58.096z",
  transform: "translate(-.428 .143)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M57.7.268c32.104 0 58.129 26.206 58.129 58.532 0 32.326-26.025 58.531-58.128 58.531S-.427 91.126-.427 58.8 25.598.268 57.701.268"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#resiliency_svg__i)",
  d: "M58.129.125c32.103 0 58.128 26.206 58.128 58.532 0 32.326-26.025 58.531-58.128 58.531S0 90.983 0 58.657 26.026.125 58.129.125",
  opacity: 0.749,
  transform: "translate(-.428 .143)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  fillRule: "nonzero",
  xlinkHref: "#resiliency_svg__o"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#resiliency_svg__p)",
  transform: "translate(356 95)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#resiliency_svg__e)",
  d: "M58.096.124v117.063h17.891c32.334 0 58.5-26.185 58.5-58.531 0-15.403-6.158-30.293-16.934-41.588C106.263 6.286 91.382.124 75.987.124H58.096z",
  transform: "translate(-.428 .135)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M57.7.26c32.104 0 58.129 26.206 58.129 58.532 0 32.326-26.025 58.531-58.128 58.531S-.427 91.118-.427 58.792 25.598.26 57.701.26"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#resiliency_svg__f)",
  d: "M58.129.125c32.103 0 58.128 26.206 58.128 58.532 0 32.326-26.025 58.531-58.128 58.531S0 90.983 0 58.657 26.026.125 58.129.125",
  opacity: 0.749,
  transform: "translate(-.428 .135)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M73.384 77.2c-.134.11-.269.22-.405.329-8.567 9.14-21.982 12.792-34.42 8.205a32.41 32.41 0 01-2.77-1.17c7.512 2.001 15.215 1.127 21.86-2.034-.441-.017-.88-.046-1.314-.088-11.974.92-23.978-5.003-30.383-16.243a33.232 33.232 0 01-1.38-2.701 32.139 32.139 0 0018.035 12.678 23.327 23.327 0 01-.852-.853c-9.818-7.08-15.299-19.475-13.067-32.3.176-1.009.395-1.999.657-2.968a32.88 32.88 0 006.164 22.009c-3.883-12.261-.358-26.224 9.98-35.012a32.692 32.692 0 012.385-1.847c-5.633 5.761-8.757 13.226-9.241 20.875 4.805-11.922 16.363-20.323 29.858-20.323 1.012 0 2.012.048 3 .14-7.97.745-15.1 4.429-20.324 9.972 11.245-6.003 25.429-4.911 35.767 3.877a32.808 32.808 0 012.209 2.06 31.83 31.83 0 00-21.896-5.596c12.423 2.724 22.596 12.798 24.94 26.262.175 1.01.303 2.015.385 3.017a32.552 32.552 0 00-13.223-18.546c7.788 10.177 9.19 24.518 2.442 36.36a33.13 33.13 0 01-1.619 2.56c3.349-7.365 3.765-15.462 1.638-22.817-.49 12.868-8.516 24.767-21.198 29.443-.95.35-1.906.653-2.865.908 7.164-3.426 12.582-9.272 15.637-16.197zM58.572 51.552a7.727 7.727 0 00-7.728 7.728v.043a7.727 7.727 0 1015.455 0v-.043a7.727 7.727 0 00-7.727-7.728z"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#resiliency_svg__q)",
  transform: "translate(104 19)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#resiliency_svg__e)",
  d: "M58.096.124v117.063h17.891c32.334 0 58.5-26.185 58.5-58.531 0-15.403-6.158-30.293-16.934-41.588C106.263 6.286 91.382.124 75.987.124H58.096z",
  transform: "translate(-.428 .308)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M57.7.433c32.104 0 58.129 26.206 58.129 58.532 0 32.326-26.025 58.531-58.128 58.531S-.427 91.291-.427 58.965 25.598.433 57.701.433"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#resiliency_svg__f)",
  d: "M58.129.125c32.103 0 58.128 26.206 58.128 58.532 0 32.326-26.025 58.531-58.128 58.531S0 90.983 0 58.657 26.026.125 58.129.125",
  opacity: 0.755,
  transform: "translate(-.428 .308)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M91.572 79.531V57.97l-8.245 8.224L60.65 43.591 46.25 57.97l-21.6-21.56-5.078 5.065L46.25 68.134l14.4-14.379 17.566 17.537-8.244 8.239z"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#resiliency_svg__r)",
  transform: "translate(437 172)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#resiliency_svg__h)",
  d: "M58.096.124v117.063h17.891c32.334 0 58.5-26.185 58.5-58.531 0-15.403-6.158-30.293-16.934-41.588C106.263 6.286 91.382.124 75.987.124H58.096z",
  transform: "translate(-.428 -.048)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M57.7.077c32.104 0 58.129 26.206 58.129 58.532 0 32.326-26.025 58.531-58.128 58.531S-.427 90.935-.427 58.61 25.598.077 57.701.077"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#resiliency_svg__i)",
  d: "M58.129.125c32.103 0 58.128 26.206 58.128 58.532 0 32.326-26.025 58.531-58.128 58.531S0 90.983 0 58.657 26.026.125 58.129.125",
  opacity: 0.749,
  transform: "translate(-.428 -.048)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M59.33 69.373c5.214 0 9.441-4.338 9.441-9.69 0-3.617-1.92-6.782-4.72-8.429L33.49 33.103l17.404 30.94c1.574 3.166 4.752 5.33 8.435 5.33zm-.76-45.353c-6.154 0-11.9 1.675-16.898 4.424l7.14 4.055c2.958-1.14 6.358-1.776 9.758-1.776 15.023 0 27.2 12.005 27.2 26.813 0 7.407-3.026 14.11-7.956 18.937h-.034a3.304 3.304 0 000 4.726c1.326 1.307 3.502 1.307 4.828.033 6.154-6.066 9.962-14.446 9.962-23.696 0-18.51-15.222-33.516-34-33.516zm-34 33.516c0 9.25 3.808 17.63 9.962 23.696a3.453 3.453 0 004.794-.033 3.304 3.304 0 000-4.726c-4.93-4.86-7.956-11.53-7.956-18.937 0-3.352.646-6.703 1.836-9.72l-4.114-7.038c-2.822 5.027-4.522 10.658-4.522 16.758z"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#resiliency_svg__s)",
  transform: "translate(356 237)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#resiliency_svg__t)",
  d: "M58.096.124v117.063h17.891c32.334 0 58.5-26.185 58.5-58.531 0-15.403-6.158-30.293-16.934-41.588C106.263 6.286 91.382.124 75.987.124H58.096z",
  transform: "translate(-.428 -.565)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M57.7-.44c32.104 0 58.129 26.206 58.129 58.532 0 32.326-26.025 58.531-58.128 58.531S-.427 90.418-.427 58.092 25.598-.44 57.701-.44"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#resiliency_svg__i)",
  d: "M58.129.125c32.103 0 58.128 26.206 58.128 58.532 0 32.326-26.025 58.531-58.128 58.531S0 90.983 0 58.657 26.026.125 58.129.125",
  opacity: 0.749,
  transform: "translate(-.428 -.565)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 7.002,
  d: "M51.489 38.315L25.572 62.307l25.917-23.992zm.29.31c-3.39-3.458-3.39-9.07 0-12.528a8.569 8.569 0 0112.284 0c3.39 3.458 3.39 9.07 0 12.528a8.569 8.569 0 01-12.284 0zM63.35 74.487l25.917-23.992L63.35 74.487zm-.29-.31c3.39 3.458 3.39 9.07 0 12.529a8.569 8.569 0 01-12.283 0c-3.39-3.458-3.39-9.071 0-12.53a8.569 8.569 0 0112.283 0z"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#resiliency_svg__u)",
  transform: "translate(189 95)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#resiliency_svg__h)",
  d: "M58.096.124v117.063h17.891c32.334 0 58.5-26.185 58.5-58.531 0-15.403-6.158-30.293-16.934-41.588C106.263 6.286 91.382.124 75.987.124H58.096z",
  transform: "translate(-.428 .023)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M57.7.148c32.104 0 58.129 26.206 58.129 58.532 0 32.326-26.025 58.531-58.128 58.531S-.427 91.006-.427 58.68 25.598.148 57.701.148"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#resiliency_svg__i)",
  d: "M58.129.125c32.103 0 58.128 26.206 58.128 58.532 0 32.326-26.025 58.531-58.128 58.531S0 90.983 0 58.657 26.026.125 58.129.125",
  opacity: 0.749,
  transform: "translate(-.428 .023)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M60.348 25.093h-7.552v37.882h7.552V25.093zm18.242 8.229l-5.362 5.377c5.967 4.819 9.792 12.195 9.792 20.49 0 14.654-11.819 26.522-26.448 26.522-14.63 0-26.448-11.868-26.448-26.522 0-8.295 3.808-15.688 9.742-20.54l-5.329-5.343c-7.323 6.261-11.965 15.507-11.965 25.883 0 18.835 15.218 34.096 34 34.096 18.781 0 34-15.261 34-34.096 0-10.376-4.643-19.622-11.982-25.867z"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#resiliency_svg__v)",
  transform: "translate(271 167)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#resiliency_svg__k)",
  d: "M58.096.124v117.063h17.891c32.334 0 58.5-26.185 58.5-58.531 0-15.403-6.158-30.293-16.934-41.588C106.263 6.286 91.382.124 75.987.124H58.096z",
  transform: "translate(-.428 .225)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M57.7.35c32.104 0 58.129 26.206 58.129 58.532 0 32.326-26.025 58.531-58.128 58.531S-.427 91.208-.427 58.882 25.598.35 57.701.35"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#resiliency_svg__l)",
  d: "M58.129.125c32.103 0 58.128 26.206 58.128 58.532 0 32.326-26.025 58.531-58.128 58.531S0 90.983 0 58.657 26.026.125 58.129.125",
  transform: "translate(-.428 .225)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M57.072 22.287c-17.397 0-31.5 13.74-31.5 30.687 0 10.33 5.355 19.843 14 25.47v12.035h7V80.25h7v10.23h7V80.25h7v10.23h7V78.41c8.645-5.627 14-15.208 14-25.436 0-16.948-14.103-30.687-31.5-30.687zm-14 30.687c3.866 0 7 3.053 7 6.819s-3.134 6.819-7 6.819-7-3.053-7-6.82c0-3.765 3.134-6.818 7-6.818zm28 0c3.866 0 7 3.053 7 6.819s-3.134 6.819-7 6.819-7-3.053-7-6.82c0-3.765 3.134-6.818 7-6.818zm-14 10.228l5.25 10.23h-10.5l5.25-10.23z"
})));

function SvgResiliency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 590 517"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/resiliency.7c76bd27.svg";
export { SvgResiliency as ReactComponent };